/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, of: NonNullable<unknown> }} Kind_Dusty_Ox_FadeInputs */

const en_kind_dusty_ox_fade = /** @type {(inputs: Kind_Dusty_Ox_FadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.of}`)
};

const de_kind_dusty_ox_fade = /** @type {(inputs: Kind_Dusty_Ox_FadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.of}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {of}" |
*
* @param {Kind_Dusty_Ox_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_dusty_ox_fade = /** @type {((inputs: Kind_Dusty_Ox_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Dusty_Ox_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_dusty_ox_fade(inputs)
	return de_kind_dusty_ox_fade(inputs)
});